import { initRemoteComponentContext, SupportedProducts } from "@bookingcom/remote-component";
import { reportError } from "@bookingcom/flights-core";
import { REMOTE_COMPONENT_PROXY_ENDPOINT } from "../../constants.js";
export async function setupRemoteComponentContext(globalContext) {
    const orcaBaseUrl = globalContext.apiPrefix
        ? globalContext.apiPrefix
        : `${window.location.protocol}//${window.location.host}`;
    const boundedFetch = window.fetch.bind(window);
    const rcContextFetch = (input, requestInitOptions) => {
        const fetchParams = { ...requestInitOptions, credentials: "include" };
        return boundedFetch(input, fetchParams);
    };
    const rcContextLogger = { logError: reportError, logWarning: reportError };
    const rcContextOptions = {
        orcaUrl: orcaBaseUrl.concat(REMOTE_COMPONENT_PROXY_ENDPOINT),
        product: SupportedProducts.Flights,
        translationRequestContext: {}
    };
    const elementWithNonce = document.querySelector("script[nonce]");
    let cspNonce;
    if (elementWithNonce) {
        cspNonce = elementWithNonce["nonce"] || elementWithNonce.getAttribute("nonce");
    }
    return initRemoteComponentContext(rcContextFetch, rcContextOptions, rcContextLogger, cspNonce);
}
